// Floating article text-size control. The chosen scale is kept in a cookie so the
// server can apply it on the next page load (see TextSizeHelper).

const COOKIE = "dp_text_scale";
const ONE_YEAR = 60 * 60 * 24 * 365;

export function setupTextSize() {
	const control = document.querySelector("[data-text-size]");
	if (!control || !document.querySelector(".dp-prose")) return;

	const root = document.documentElement;
	const scales = control.dataset.scales.split(",");
	const label = control.querySelector("[data-text-size-label]");
	const status = control.querySelector("[data-text-size-status]");
	const smaller = control.querySelector('[data-text-size-step="-1"]');
	const larger = control.querySelector('[data-text-size-step="1"]');

	const currentIndex = () => {
		const value = root.style.getPropertyValue("--dp-text-scale").trim() || "1";
		const index = scales.indexOf(value);
		return index === -1 ? scales.indexOf("1") : index;
	};

	const render = (index, announce) => {
		const percent = `${Math.round(Number(scales[index]) * 100)}%`;
		label.textContent = percent;
		smaller.disabled = index === 0;
		larger.disabled = index === scales.length - 1;
		if (announce) status.textContent = `Article text ${percent}`;
	};

	const apply = (index) => {
		const scale = scales[index];
		if (scale === "1") {
			root.style.removeProperty("--dp-text-scale");
		} else {
			root.style.setProperty("--dp-text-scale", scale);
		}
		document.cookie = `${COOKIE}=${scale}; path=/; max-age=${ONE_YEAR}; SameSite=Lax`;
		render(index, true);
	};

	control.addEventListener("click", (event) => {
		const button = event.target.closest("button");
		if (!button || button.disabled) return;

		if (button.hasAttribute("data-text-size-reset")) {
			apply(scales.indexOf("1"));
		} else {
			const step = Number(button.dataset.textSizeStep);
			apply(Math.min(scales.length - 1, Math.max(0, currentIndex() + step)));
		}
	});

	render(currentIndex(), false);
	control.hidden = false;
}
